/**
 * @file DatePicker.tsx
 * @module app/custom/DateRange/DatePicker
 * @description Renders the DatePicker control for selecting and formatting date or date-range filters in report and list workflows.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import "./dateRange.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
const CustomDatePicker = (props: any) => {
  const toMidnight = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const isWithinRange = (date: Date) => {
    const value = toMidnight(date).getTime();
    const min = props.minDate ? toMidnight(new Date(props.minDate)).getTime() : null;
    const max = props.maxDate ? toMidnight(new Date(props.maxDate)).getTime() : null;

    if (min !== null && value < min) return false;
    if (max !== null && value > max) return false;
    return true;
  };

  return (
    <>
      <DatePicker
        className={`${props.className || ""} form-control border border-r8px ${
          props.selectsRange ? "date-range-min-width" : ""
        }`}
        selected={props.selected}
        onChange={props.onChange}
        startDate={props.startDate}
        endDate={props.endDate}
        dateFormat={props.dateFormat}
        selectsRange={props.selectsRange}
        showFullMonthYearPicker={props.showFullMonthYearPicker}
        showYearDropdown={props.showYearDropdown}
        scrollableYearDropdown={props.scrollableYearDropdown}
        dropdownMode={props.dropdownMode}
        maxDate={props.maxDate}
        isClearable={props.isClearable}
        disabled={props.disabled}
        minDate={props.minDate}
        filterDate={isWithinRange}
        placeholderText={props.placeholderText || (props.selectsRange ? "Select Dates" : "Select Date")}
        yearDropdownItemNumber={props.yearDropdownItemNumber ?? 100}
        shouldCloseOnSelect={false}
      />
    </>
  );
};
export default CustomDatePicker;
